<section class="chart-card bar-chart">
  <app-spinner-overlay [visible]="chargement" label="Chargement du graphique..." />
  <div class="chart-header">
    <h2>Production cumulée du parc</h2>
    <div class="chart-header-actions">
      <app-chart-period-selector
        [mode]="mode"
        [dateFin]="dateFin"
        [modes]="modesDisponibles"
        [navigationJourParMois]="true"
        [afficherAnneeSeuleEnModeMois]="true"
        (periodeChange)="onPeriodeChange($event)"
      />
      <div class="chart-menu-wrapper">
        <button class="menu-dots" aria-label="Options du graphique"
                (click)="toggleMenu($event)">
          <span></span>
        </button>
        @if (menuOuvert) {
          <div class="chart-dropdown" role="menu">
            <button class="chart-dropdown-item" role="menuitem"
                    (click)="ouvrirModal()">
              <span class="material-symbols-outlined">fullscreen</span>
              Afficher en grand
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <div
    #chartHost
    class="chart-area chart-area-bars chart-area-bars-amchart"
    [class.chart-area-hidden]="!!messageGraphique"
    aria-label="Graphique de production cumulée du parc"
  ></div>

  @if (messageGraphique) {
    <div class="chart-empty-state" role="status" aria-live="polite">
      <p>{{ messageGraphique }}</p>
    </div>
  }
</section>

<app-chart-fullscreen-modal
  title="Production cumulée du parc"
  [chartRenderer]="cumuleeChartRenderer"
  [(visible)]="modalVisible"
  [refreshToken]="modalRefreshToken"
  [loading]="chargement"
>
  <div chart-controls class="chart-header-actions">
    <app-chart-period-selector
      [mode]="mode"
      [dateFin]="dateFin"
      [modes]="modesDisponibles"
      [navigationJourParMois]="true"
      [afficherAnneeSeuleEnModeMois]="true"
      (periodeChange)="onPeriodeChange($event)"
    />
  </div>
</app-chart-fullscreen-modal>
